"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withAnalytics = exports.useAnalyticsQueryParam = exports.useAnalytics = exports.initAnalyticsListener = exports.default = exports.AnalyticsProvider = void 0;
var _react = require("react");
var _getUrlParams = _interopRequireDefault(require("../../packages/getUrlParams"));
var _jsxRuntime = require("react/jsx-runtime");
var _window$TMNA$analytic, _window, _window$TMNA, _window$TMNA$analytic2;
const isAnalyticsDisabled = function () {
  const disableAnalytics = (0, _getUrlParams.default)("disableAnalytics");
  return disableAnalytics;

  /* 
  	Todo: This was to rely on ensighten to determine if analytics is disabled, but an issue occurs in that ensighten is asynchronously loaded,
  	leading to a situation where analytics does not fire on initial page load.
  */
  // return typeof window.Bootstrapper === "undefined";
};
window.TMNA = window.TMNA || {};
window.TMNA.analytics = {
  data: {},
  _queue: [],
  enableQueue: (_window$TMNA$analytic = (_window = window) === null || _window === void 0 ? void 0 : (_window$TMNA = _window.TMNA) === null || _window$TMNA === void 0 ? void 0 : (_window$TMNA$analytic2 = _window$TMNA.analytics) === null || _window$TMNA$analytic2 === void 0 ? void 0 : _window$TMNA$analytic2.enableQueue) !== null && _window$TMNA$analytic !== void 0 ? _window$TMNA$analytic : false,
  flushQueue: function () {
    window.TMNA.analytics._queue.forEach(function (i) {
      i();
    });
    window.TMNA.analytics.enableQueue = false;
  }
};

/*
	Enable Queuing with
	window.TMNA = {
		analytics: {
			enableQueue: true,
		}
	}
*/

function withQueuedCall(fn) {
  if (!window.TMNA.analytics.enableQueue) {
    return fn;
  }
  return function (action) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!window.TMNA.analytics.enableQueue) {
      fn(action, props);
    } else {
      window.TMNA.analytics._queue.push(function () {
        return fn(action, props);
      });
    }
  };
}

// Todo: Filter out functions from data being returned to analytics
const AnalyticsContext = /*#__PURE__*/(0, _react.createContext)([]);
const useAnalyticsData = function (namespace, initial) {
  const context = (0, _react.useContext)(AnalyticsContext);
  let _tree = context || [];
  const lastEvent = _tree.length > 0 ? _tree[_tree.length - 1] : {};
  const isVirtualEvent = namespace !== "" && (lastEvent === null || lastEvent === void 0 ? void 0 : lastEvent._component) !== namespace;
  if (typeof initial !== "undefined") {
    context[context.length - 1]._state = {
      ...(context[context.length - 1]._state || {}),
      ...(initial || {})
    };
  }
  const flat = context.reduce(function (acc, _ref) {
    let {
      _state,
      _props,
      ...inc
    } = _ref;
    return {
      ...acc,
      ..._props,
      ..._state,
      ...inc
    };
  }, {});
  return function (action) {
    var _window$TMNA$analytic3, _window2, _window2$TMNA, _window2$TMNA$analyti, _flat$useOnFireAnalyt;
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const eventName = `${namespace && namespace + "/"}${action}`;
    if (isVirtualEvent) {
      // every event needs an entry in the tree, even if the component is not wrapped by analytics
      const prev = _tree.at(-1);
      if (prev && prev._component === namespace) {
        _tree[_tree.length - 1] = {
          _component: namespace,
          _props: props,
          _state: initial,
          _isVirtual: true
        };
      } else {
        _tree = [..._tree, {
          _component: namespace,
          _props: props,
          _state: initial,
          _isVirtual: true
        }];
      }
    }
    if (action.indexOf("/") !== -1) {
      _tree = [..._tree, {
        _component: action.split("/")[0],
        _props: props,
        _state: initial
      }];
    }
    const resolved = {
      ...((_window$TMNA$analytic3 = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$TMNA = _window2.TMNA) === null || _window2$TMNA === void 0 ? void 0 : (_window2$TMNA$analyti = _window2$TMNA.analytics) === null || _window2$TMNA$analyti === void 0 ? void 0 : _window2$TMNA$analyti.data) !== null && _window$TMNA$analytic3 !== void 0 ? _window$TMNA$analytic3 : {}),
      ...((flat === null || flat === void 0 ? void 0 : (_flat$useOnFireAnalyt = flat.useOnFireAnalytics) === null || _flat$useOnFireAnalyt === void 0 ? void 0 : _flat$useOnFireAnalyt.call(flat)) || {})
    };
    const data = {
      _tree,
      ...flat,
      ...props,
      ...resolved
    };
    return [eventName, data];
  };
};
function replaceBracesContent(str, obj) {
  return str.replace(/{([^}]+)}/g, function (match, key) {
    return obj.hasOwnProperty(key) ? encodeURIComponent(obj[key].replaceAll(" ", "")) : match;
  });
}

/**
 *
 * Usage:
 * const withIntsrcSearchParams = useAnaltyicsQueryParam({intsrc: "{brand}:{section}:{action}:{destination}"});
 * const output = withIntsrcSearchParams(url, "dealervisit", { destination: "" })
 *
 */
const DEFAULT_ACTION = "dealervisit";
const useAnalyticsQueryParam = function (query, initial) {
  const getData = useAnalyticsData("", initial);
  return function (url, props) {
    var _props$action, _data$app, _data$app2, _data$theme;
    if (isAnalyticsDisabled()) {
      return url;
    }

    // Handle empty or invalid URLs
    if (!url) {
      return url;
    }
    const [, data] = getData((_props$action = props === null || props === void 0 ? void 0 : props.action) !== null && _props$action !== void 0 ? _props$action : DEFAULT_ACTION, props);
    const isToyota = (data === null || data === void 0 ? void 0 : (_data$app = data.app) === null || _data$app === void 0 ? void 0 : _data$app.toLowerCase()) === "t" || (data === null || data === void 0 ? void 0 : (_data$app2 = data.app) === null || _data$app2 === void 0 ? void 0 : _data$app2.toLowerCase()) === "tcom" || (data === null || data === void 0 ? void 0 : (_data$theme = data.theme) === null || _data$theme === void 0 ? void 0 : _data$theme.toLowerCase()) === "toyota";
    const brand = isToyota ? "tcom" : "lcom";
    const dataWithBrand = {
      action: DEFAULT_ACTION,
      ...data,
      brand
    };
    try {
      // Handle relative URLs by using current origin
      const baseUrl = url.startsWith("http") ? url : `${window.location.origin}${url}`;
      const hrefURL = new URL(baseUrl);
      if (props !== null && props !== void 0 && props.dealerPageType) {
        hrefURL.searchParams.set("dealerPageType", props.dealerPageType);
      }
      for (let k in query) {
        const value = query[k];
        hrefURL.searchParams.set(k, replaceBracesContent(value, dataWithBrand));
      }

      // For relative URLs, return just the pathname + search
      if (!url.startsWith("http")) {
        return `${hrefURL.pathname}${hrefURL.search}`;
      }
      return hrefURL.toString().replace(/%3A/g, ":");
    } catch (e) {
      console.warn("[Analytics Hook][URL Error]", e);
      return url; // Return original URL if parsing fails
    }
  };
};
exports.useAnalyticsQueryParam = useAnalyticsQueryParam;
const useAnalytics = function (namespace) {
  let initial = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const getData = useAnalyticsData(namespace, initial);
  return withQueuedCall(function (action) {
    let props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (isAnalyticsDisabled()) {
      return;
    }
    const [eventName, data] = getData(action, props);
    try {
      if (window.top !== window.self && typeof window.parent.dispatchEvent === "function") {
        window.parent.dispatchEvent(new CustomEvent("LEXUS_ANALYTICS_EVENT", {
          detail: {
            eventName,
            data: {
              ...data,
              origin: window.location.href,
              isIframe: true
            }
          }
        }));
      }
      window.dispatchEvent(new CustomEvent("LEXUS_ANALYTICS_EVENT", {
        detail: {
          eventName,
          data: {
            ...data,
            origin: window.location.href,
            isIframe: false
          }
        }
      }));
    } catch (e) {
      console.log("[Analytics Hook][Error]", e);
    }
  });
};
exports.useAnalytics = useAnalytics;
const AnalyticsProvider = function (_ref2) {
  let {
    data: {
      _component,
      ...data
    } = {},
    children
  } = _ref2;
  const context = (0, _react.useContext)(AnalyticsContext);
  const state = (0, _react.useRef)({});
  const treeRef = (0, _react.useRef)();
  const dataWithRef = {
    _component,
    _props: data,
    _state: state.current
  };
  const tree = [...context, dataWithRef];
  treeRef.current = tree;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(AnalyticsContext.Provider, {
    value: treeRef.current,
    "data-testid": "AnalyticsProvider",
    children: children
  });
};
exports.AnalyticsProvider = AnalyticsProvider;
const withAnalytics = function (Component) {
  return function () {
    var _ref3;
    let analytics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const _component = (_ref3 = analytics._component || (Component === null || Component === void 0 ? void 0 : Component.displayName) || Component.name) === null || _ref3 === void 0 ? void 0 : _ref3.split("$").at(0);
    const ComponentWithAnalytics = function (_ref4) {
      let {
        ...props
      } = _ref4;
      const data = {
        _component,
        ...analytics,
        ...props
      };
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(AnalyticsProvider, {
        data: data,
        "data-testid": "ComponentWithAnalytics",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
          ...props
        })
      });
    };
    if (_component) {
      ComponentWithAnalytics.displayName = `${_component}WithAnalytics`;
    }
    return ComponentWithAnalytics;
  };
};
exports.withAnalytics = withAnalytics;
const initAnalyticsListener = function () {
  let handler = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  window.addEventListener("LEXUS_ANALYTICS_EVENT", handler, false);
};
exports.initAnalyticsListener = initAnalyticsListener;
var _default = exports.default = useAnalytics;